import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import { AuthProvider, getGoogleClientId } from './auth/AuthContext';

const googleClientId = getGoogleClientId();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const app = (
  <AuthProvider>
    <App />
  </AuthProvider>
);

root.render(
  <React.StrictMode>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        {app}
      </GoogleOAuthProvider>
    ) : (
      app
    )}
  </React.StrictMode>
);
